var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.17298 7.67058C1.7149 7.67058 1.34356 8.04192 1.34356 8.5C1.34356 8.95808 1.7149 9.32942 2.17298 9.32942L7.24165 9.32942L7.24165 9.39809C7.24165 9.85617 7.61299 10.2275 8.07107 10.2275C8.52914 10.2275 8.90049 9.85617 8.90049 9.39809L8.90049 9.32942L13.9692 9.32942C14.4272 9.32942 14.7986 8.95808 14.7986 8.5C14.7986 8.04192 14.4272 7.67058 13.9692 7.67058L8.90049 7.67058L8.90049 7.60191C8.90049 7.14383 8.52914 6.77249 8.07107 6.77249C7.61299 6.77249 7.24165 7.14383 7.24165 7.60191L7.24165 7.67058L2.17298 7.67058Z",
    fill: "#009AE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minus-icon.fab0838308e80fe45ae9ce9f77cf12e0.svg";
export { ForwardRef as ReactComponent };